<div class="pledge-report-dialog">
    <div class="dialog-header flex-centered-container padding">
        <h2 class="dialog-title font-600 font-14 text-center margin-0">Pledge Report</h2>
        <button mat-icon-button [mat-dialog-close]="true" class="close-btn">
            <span class="material-icons">clear</span>
        </button>
    </div>

    <div class="dialog-content">
        <!-- Successful Pledges Section -->
        <div *ngIf="data.successfulPledges && data.successfulPledges.length > 0" class="pledge-section success-section">
            <h3 class="section-title success-title font-600">Pledged Successfully!</h3>
            <p class="section-description font-12">{{ PLEDGE_SUCCESS_MESSAGE }}</p>

            <div class="symbols-container display-flex">
                <div *ngFor="let symbol of data.successfulPledges" class="symbol-chip success-chip">
                    {{ symbol }}
                </div>
            </div>
        </div>

        <!-- Failed Pledges Section -->
        <div *ngIf="data.failedPledges && data.failedPledges.length > 0" class="pledge-section failed-section">
            <h3 class="section-title failed-title font-600">Pledge Failed!</h3>
            <p class="section-description font-12">{{ PLEDGE_FAILURE_MESSAGE }}</p>

            <div class="symbols-container display-flex">
                <div *ngFor="let symbol of data.failedPledges" class="symbol-chip failed-chip">
                    {{ symbol }}
                </div>
            </div>
        </div>

        <!-- Overdue Pledges Section -->
        <div *ngIf="data.overduePledges && data.overduePledges.length > 0" class="pledge-section overdue-section">
            <h3 class="section-title overdue-title font-600">Pledge In Progress/Overdue!</h3>
            <p class="section-description font-12">{{ PLEDGE_OVERDUE_MESSAGE }}</p>

            <div class="symbols-container display-flex">
                <div *ngFor="let symbol of data.overduePledges" class="symbol-chip overdue-chip">
                    {{ symbol }}
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-actions align-items-center flex-space-end">
        <button mat-flat-button color="primary" [mat-dialog-close]="true"
            class="continue-btn font-600 border-radius-8 font-14">Continue</button>
    </div>
</div>